export default __webpack_public_path__ + "static/media/art-pro-red-2.44f0dba6.png";